import { api } from "@/http/api-client"

export type TDeleteCategoryParams = {
  organizationSlug: string
  categoryId: string
}

export function deleteCategory(params: TDeleteCategoryParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.delete(
    `/finances/categories/${params.categoryId}?${searchParams.toString()}`,
  )
}
